import { useGetQuoteQuery } from './studioApi'
import { multiplyCredits } from './lib/money'

export interface BlockEditQuoteView {
  /** `per_block × N`. Счётчика блоков в смете нет НАМЕРЕННО (§6.1). */
  price?: string
  balance?: string
  isLoading: boolean
}

/**
 * Цена правки: `per_block × N`. Счётчика блоков в смете нет НАМЕРЕННО
 * (§6.1) — умножаем на фронте, на строках: деньги к `Number` не приводим.
 *
 * Чтение защитное по всей цепочке — тем же стилем, что `useCourseQuote` и
 * `useImageQuote`: неполный ответ не должен ронять панель.
 */
export const useBlockEditQuote = (
  courseId: number,
  count: number,
  skip: boolean,
): BlockEditQuoteView => {
  const { data, isFetching } = useGetQuoteQuery(courseId, { skip })
  const perBlock = data?.block_edit?.per_block
  return {
    price: perBlock && count > 0 ? multiplyCredits(perBlock, count) : undefined,
    balance: data?.balance,
    isLoading: !skip && isFetching,
  }
}
